import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { LocalizedText, FormSelectField, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropdownItem } from '@optimus-web/core';
import { getMailTypeTextKey } from '../../helpers';

interface EmailTypesSelectFieldProps {
    availableEmailTypes: string[];
}

export const EmailTypesSelectField = ({ availableEmailTypes }: EmailTypesSelectFieldProps) => {
    const localizeText = useLocalizeText();

    return (
        <FormSelectField
            required
            name="emailTypes"
            label={<LocalizedText textKey={TextKey.WhitelistedUserEmailsTableHeaderEmailTypes} />}
            helper={<LocalizedText textKey={TextKey.WhitelistedUserEmailsTableHeaderEmailTypesHelper} />}
            multiselect
        >
            {pipe(
                availableEmailTypes,
                array.map((key) => {
                    const textKey = getMailTypeTextKey(key);
                    const primaryText = textKey ? localizeText({ textKey }) : key;

                    return <DropdownItem key={key} value={key} label={primaryText} />;
                })
            )}
        </FormSelectField>
    );
};
